import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { SlotRead } from '../../entities/slot.dto';

@Injectable()
export class SlotStore extends AbstractEntityStore<SlotRead> {
    override addToTopOfPage = false;

    constructor() {
        super(PFWmsEntities.Slot);
    }
}
